import { Divider, Group, Paper, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';

type AllClearStripProps = {
  companyNames: string[];
};

export const AllClearStrip = ({ companyNames }: AllClearStripProps) => {
  const { t } = useTranslation();

  if (companyNames.length === 0) return null;

  return (
    <>
      <Group gap={12} mt={32} mb="md">
        <Text
          ff="heading"
          fz={13}
          fw={500}
          tt="uppercase"
          c="gray.5"
          style={{ letterSpacing: '0.04em' }}
        >
          {t(i18nKeys.GROUP.ALL_CLEAR)}
        </Text>
        <Divider flex={1} color="gray.2" />
      </Group>

      <Group gap={8}>
        {companyNames.map(companyName => (
          <Paper key={companyName} withBorder radius={10} px={14} py={9}>
            <Group gap={8} wrap="nowrap">
              <IconCheck size={14} stroke={2.2} color="var(--mantine-color-gray-4)" />
              <Text fz={14} c="gray.6">
                {companyName}
              </Text>
            </Group>
          </Paper>
        ))}
      </Group>
    </>
  );
};
